import React, { Component, useContext, useEffect, useState } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Footer from "./Footer";
import Header from "./Header";
import Menu from "./Menu";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import StarekContext from "../context/StarekContext";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { SETTING, useSetting } from "../hooks/useSettings";

const AppLayout = (props) => {
    const starekContext = useContext(StarekContext);
    const location = useLocation();
    const toastDurationMs = useSetting(SETTING.TOAST_DURATION_MS, 6000);
    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        starekContext.setSnackbarNotification(null);
    };
    return starekContext?.auth ? (
        <>
            <div className="wrapper">
                <Header hasLeftMargin={true}></Header>
                <Menu></Menu>
                <div
                    className="content-wrapper"
                    style={{ minHeight: "calc(100vh - 180px)" }}
                >
                    <Stack
                        spacing={2}
                        sx={{ width: "100%" }}
                        className="tw-mt-4"
                    >
                        <Snackbar
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "center",
                            }}
                            open={starekContext.snackbarNotification != null}
                            autoHideDuration={toastDurationMs}
                            onClose={handleClose}
                        >
                            {starekContext.snackbarNotification && (
                                <Alert
                                    onClose={handleClose}
                                    severity={
                                        starekContext.snackbarNotification?.type
                                    }
                                    sx={{
                                        width: "100%",
                                        backgroundColor:
                                            starekContext.snackbarNotification
                                                ?.type === "info"
                                                ? "var(--bs-info)"
                                                : starekContext
                                                        .snackbarNotification
                                                        ?.type === "warning"
                                                  ? "var(--bs-warning)"
                                                  : starekContext
                                                          .snackbarNotification
                                                          ?.type === "error"
                                                    ? "var(--bs-danger)"
                                                    : starekContext
                                                            .snackbarNotification
                                                            ?.type === "success"
                                                      ? "var(--bs-success)"
                                                      : undefined,
                                        fontWeight: 700,
                                        "& .MuiAlert-message": {
                                            color:
                                                starekContext
                                                    .snackbarNotification
                                                    ?.type === "warning"
                                                    ? "var(--bs-dark)"
                                                    : "#fff !important",
                                        },
                                    }}
                                >
                                    {starekContext.snackbarNotification?.text}
                                </Alert>
                            )}
                        </Snackbar>
                    </Stack>
                    <CSSTransition
                        key={location.pathname}
                        in={true}
                        timeout={300}
                        classNames="page-crossfade"
                    >
                        <div>{props.children}</div>
                    </CSSTransition>
                </div>
                <Footer></Footer>
            </div>
        </>
    ) : (
        <Navigate to={"/login"}></Navigate>
    );
};

export default AppLayout;
